import type { ConstValues } from './helpers';

export const DistributionChannel = {
  Web: 'WEB',
  App: 'APP',
} as const;
export type DistributionChannel = ConstValues<typeof DistributionChannel>;
